import type { RumBeforeSend } from '@datadog/browser-rum';

const boundaryCaughtErrors = new WeakSet<object>();

const isBoundaryCaught = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && boundaryCaughtErrors.has(error);

/**
 * Must run while the fallback renders: React prints the caught error to the console during the
 * following commit, before any boundary callback, and that print is the copy to drop.
 */
export const noteBoundaryCaughtError = (error: unknown) => {
  if (typeof error === 'object' && error !== null) boundaryCaughtErrors.add(error);
};

export const keepUnlessConsoleCopyOfBoundaryError: RumBeforeSend = (event, context) =>
  !(
    event.type === 'error' &&
    event.error.source === 'console' &&
    'error' in context &&
    isBoundaryCaught(context.error)
  );
